<template>
	<footer class="app-footer">
		<div class="container">

			<div class="small">
				<span class="glyphicon glyphicon-copyright-mark"></span> <strong>{{name}}</strong> {{desc}} |
				<a href="tel:+972525865589" title="Reach us by phone"><span class="glyphicon glyphicon-earphone"></span> (972) 52-5865589</a> |
				<a href="mailto:info@weboko.co.il" title="Write us an E-mail"><span class="glyphicon glyphicon-envelope"></span> E-Mail Us</a>
			</div>

		</div>
	</footer>
</template>

<script>
	export default {
		name: 'appFooter',
		props: ['name', 'desc'],
		data () {
			return {
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.app-footer { min-height:160px; padding-top:20px; border-top: 5px solid #ccc; background: #e5e5e5;  }
</style>



// WEBPACK FOOTER //
// appFooter.vue?2f52f492